export interface OrderLineStatusCheck {
  success: boolean;
  error: string;
}
